module.exports = __webpack_public_path__ + "img/login-desc.f8f5b63e.png";